import { render, staticRenderFns } from "./DepositDetailTemp.vue?vue&type=template&id=71726ca7&scoped=true"
import script from "./DepositDetailTemp.vue?vue&type=script&lang=js"
export * from "./DepositDetailTemp.vue?vue&type=script&lang=js"
import style0 from "./DepositDetailTemp.vue?vue&type=style&index=0&id=71726ca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71726ca7",
  null
  
)

export default component.exports